import {createRouter, createWebHistory} from 'vue-router'
import ProfileView from '../views/ProfileView.vue'
import caseView from '../views/caseView.vue'


const routes = [
    {
        path: '/',
        name: 'profile',
        component: ProfileView,
    },
    {
        path: '/caseview/:caseid/:fetchCaseDetailsFrom/:partnerId/:caseYear',
        name: 'case',
        component: caseView,
    },
    {
        path: "/:catchAll(.*)",
        component: () => import( '../views/NotfoundView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
